import { className } from '../../../../Utils';


import './AccordionContentDesktop.css'

const AccordionContentDesktop = ({ content, itemTitle }) => {
    return (
        <article className={className('accordion-container')}>
            <div className={className('accordion-content')}>
                <div className={className('accordion-content-wrapper')}>
                    <h5>
                        {itemTitle}
                    </h5>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: content,
                        }}
                    ></p>
                </div>
          
            </div>
        </article>
    )
}

export default AccordionContentDesktop
